import { CHANNEL } from '../constants/messageTemplateKeys';

export function resolveTabKeyByChannel(channel = CHANNEL.EMAIL) {
  const normalized = String(channel ?? CHANNEL.EMAIL).toLowerCase();
  return normalized === CHANNEL.EMAIL ? CHANNEL.EMAIL : 'text';
}
